export default "__VITE_ASSET__BymAmiBo__"